// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HEADER DU PROFIL */
.public-profile-header {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 25px;
}

/* AVATAR */
.public-profile-avatar {
    width: 70px;              /* Taille cohérente avec ton thème */
    height: 70px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid var(--border-color);
}

/* NOM */
.public-profile-name {
    margin: 0;
    font-size: 18px;          /* Même taille que tes titres secondaires */
    font-weight: 600;
}

/* ROLE */
.public-profile-role {
    margin-top: 4px;
    opacity: 0.7;
    font-size: 14px;
}

/* SECTIONS */
.public-profile-section {
    margin-top: 25px;
}

.public-profile-section h4 {
    margin-bottom: 8px;
    font-size: 15px;
    opacity: 0.8;
}

.public-profile-section p,
.public-profile-section li {
    font-size: 14px;
    opacity: 0.9;
}

/* LISTE DES STATS */
.public-profile-section ul {
    padding-left: 18px;
}

/* BANNIÈRE */
.profile-banner {
    position: relative;
    width: 100%;
    height: 180px;
    border-radius: 12px;
    overflow: visible;
    margin-bottom: 40px; /* pour laisser la place à l’avatar */
}

.profile-banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: bottom;
    border-radius: 12px;
}

/* TITRE DU PROFIL */
.chart-title {
    margin: 0; /* reset margin so vertical alignment is controlled by the row */
    font-size: 20px;
    line-height: 1;
}

/* Title row with aligned actions */
.profile-title-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 10px; /* keep previous spacing from avatar */
}

.profile-title-row .chart-title {
    display: inline-flex;
    align-items: center;
}

.logs-btn {
    height: 36px;
    min-width: 36px;
    padding: 6px 10px;
}

/* SECTIONS */
.public-profile-section {
    margin-top: 25px;
}

.public-profile-section h4 {
    margin-bottom: 8px;
    font-size: 15px;
    opacity: 0.8;
}

.public-profile-section p,
.public-profile-section li {
    font-size: 14px;
    opacity: 0.9;
}

.public-profile-badges {
    display: flex;
    gap: 8px;
    margin-top: 6px;
    flex-wrap: wrap;
}

/* Style général */
.badge {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    color: white;
}

/* Couleurs selon le rôle */
/* Container des badges */
.public-profile-badges {
    display: flex;
    gap: 8px;
    margin-top: 6px;
    flex-wrap: wrap;
}

/* Badge Admin animé */
.badge-admin-animated {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    color: white;
    background: linear-gradient(90deg, #ff4d4d, #ff1a1a);
    box-shadow: 0 0 8px rgba(255, 50, 50, 0.6);
    animation: adminGlow 2s infinite alternate ease-in-out;
}

/* Icône */
.badge-admin-animated i {
    font-size: 12px;
}

/* Animation glow */
@keyframes adminGlow {
    0% {
        box-shadow: 0 0 6px rgba(255, 50, 50, 0.4);
        transform: translateY(0px);
    }
    100% {
        box-shadow: 0 0 14px rgba(255, 50, 50, 0.9);
        transform: translateY(-1px);
    }
}


.badge-mod {
    background: #3498db; /* bleu */
}

.badge-user {
    background: #7f8c8d; /* gris */
}

.badge i {
    font-size: 12px;
}

.edit-url-box {
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 12px;
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    display: flex;
    gap: 10px;
    align-items: center;
    position: static; /* 🔥 IMPORTANT */
}



.edit-url-box input {
    flex: 1 1;
    padding: 8px;
    border-radius: 6px;
    border: 1px solid var(--border-color);
    background: var(--card-bg);
    color: var(--text-color);
}

.save-url-btn {
    padding: 8px 14px;
    background: var(--accent-color);
    color: white;
    border-radius: 6px;
    border: none;
    cursor: pointer;
}

.cancel-url-btn {
    padding: 8px 14px;
    background: #555;
    color: white;
    border-radius: 6px;
    border: none;
    cursor: pointer;
}


/* Bouton modifier bannière */
.edit-banner-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
    background: rgba(0,0,0,0.5);
    color: white;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 13px;
    border: none;
    cursor: pointer;
    backdrop-filter: blur(4px);
    transition: 0.2s;
}

.edit-banner-btn:hover {
    background: rgba(0,0,0,0.7);
}

/* Bouton modifier avatar */
.edit-avatar-btn {
    position: absolute;
    bottom: -10px;
    left: 110px;
    background: var(--card-bg);
    border: 2px solid var(--border-color);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 0.2s;
}

.edit-avatar-btn:hover {
    transform: scale(1.1);
}

/* AVATAR QUI DÉPASSE DE LA BANNIÈRE */
/*.profile-banner-avatar {*/
/*    position: absolute;*/
/*    bottom: -35px; !* dépasse comme Discord *!*/
/*    left: 30px;*/
/*    width: 80px;*/
/*    height: 80px;*/
/*    border-radius: 50%;*/
/*    border: 4px solid var(--card-bg); !* cercle propre même en dark mode *!*/
/*    object-fit: cover;*/
/*}*/


.avatar-wrapper2 {
    position: absolute; /* même positionnement que ton avatar avant */
    bottom: -35px;
    left: 40px;
    width: 80px;
    height: 80px;
}

.profile-banner-avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 4px solid var(--card-bg); /*cercle propre même en dark mode*/
    object-fit: cover;
}

/* Le point vert */
.status-dot2 {
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 3px solid var(--card-bg);
}

.status-dot2.online {
    background-color: #2ecc71;
}

.status-dot2.offline {
    background-color: #7f8c8d;
}

.profile-bio {
    margin-top: 20px;
}

.bio-textarea {
    width: 100%;
    min-height: 120px;
    padding: 12px;
    border-radius: 10px;

    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);

    border: 1px solid rgba(255, 255, 255, 0.35);
    color: var(--text-color);

    resize: none;
    outline: none;
    transition: 0.25s ease;
    padding-bottom: 32px; /* espace pour le compteur */
}

/* Effet focus moderne */
.bio-textarea:focus {
    border-color: var(--accent-color);
    box-shadow: 0 0 8px rgba(52, 152, 219, 0.4);
}

/* Thème sombre */
[data-theme="dark"] .bio-textarea {
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.2);
}

[data-theme="dark"] .bio-textarea:focus {
    border-color: var(--accent-color);
    box-shadow: 0 0 8px rgba(74, 163, 255, 0.4);
}



.bio-actions {
    margin-top: 10px;
    display: flex;
    gap: 10px;
}

.save-bio-btn {
    padding: 8px 14px;
    background: var(--accent-color);
    color: white;
    border-radius: 6px;
    border: none;
    cursor: pointer;
}

.cancel-bio-btn {
    padding: 8px 14px;
    background: #555;
    color: white;
    border-radius: 6px;
    border: none;
    cursor: pointer;
}

.edit-glass-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;

    padding: 7px 12px;
    border-radius: 10px;

    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);

    border: 1px solid rgba(255, 255, 255, 0.25);

    color: var(--text-color);
    font-size: 14px;
    cursor: pointer;

    transition: 0.25s ease;
}

/* Icône */
.edit-glass-btn i {
    font-size: 14px;
}

/* Hover */
.edit-glass-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.45);
    transform: translateY(-2px);
}

/* Thème sombre */
[data-theme="dark"] .edit-glass-btn {
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.15);
}

/* Logs modal */
.logs-btn {
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    color: var(--text-color);
    padding: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.logs-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1200;
}

.logs-modal {
    width: min(1100px, 95%);
    max-height: 80vh;
    background: var(--card-bg);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.logs-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    border-bottom: 1px solid var(--border-color);
}

.logs-modal-body {
    padding: 12px 16px;
    overflow: auto;
    flex: 1 1 auto;
}

.logs-modal-footer {
    padding: 10px 16px;
    border-top: 1px solid var(--border-color);
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.close-modal {
    background: transparent;
    border: none;
    font-size: 22px;
    cursor: pointer;
    color: var(--text-color);
}

.logs-table {
    width: 100%;
    border-collapse: collapse;
}

.logs-table th, .logs-table td {
    padding: 8px 10px;
    text-align: left;
    border-bottom: 1px solid var(--border-color);
    font-size: 13px;
}

.load-more {
    padding: 8px 12px;
    min-width: 140px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: transparent;
    color: var(--accent-color);
    border: 1px solid var(--accent-color);
    border-radius: 10px;
    cursor: pointer;
    font-weight: 600;
    box-shadow: 0 6px 18px rgba(16,24,40,0.04);
    transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease, color 160ms ease;
}

.load-more:hover {
    transform: translateY(-3px);
    background: var(--accent-color);
    color: white;
    box-shadow: 0 10px 24px rgba(16,24,40,0.08);
}

.load-more:active {
    transform: translateY(-1px);
}

.load-more:focus {
    outline: 2px solid rgba(0,0,0,0.06);
    outline-offset: 2px;
}

.load-more[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* Dark theme: subtle light-outline, hover fills with accent to remain visible */
.dark .load-more,
[data-theme="dark"] .load-more {
    background: rgba(255,255,255,0.03);
    color: var(--text-color);
    border: 1px solid rgba(255,255,255,0.06);
    box-shadow: 0 6px 18px rgba(0,0,0,0.5);
}

.dark .load-more:hover,
[data-theme="dark"] .load-more:hover {
    background: var(--accent-color);
    color: white;
    box-shadow: 0 10px 26px rgba(0,0,0,0.6);
}

[data-theme="dark"] .edit-glass-btn:hover {
    background: rgba(0, 0, 0, 0.35);
    border-color: rgba(255, 255, 255, 0.35);
}

.bio-edit-container {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.bio-counter {
    font-size: 13px;
    opacity: 0.7;
    text-align: right;
    width: fit-content;
    margin-left: auto;

    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(6px);
    padding: 4px 8px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Thème sombre */
[data-theme="dark"] .bio-counter {
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.15);
}

/* Warning quand on approche de la limite */
.bio-counter.warning {
    color: #e74c3c;
    border-color: rgba(231, 76, 60, 0.4);
}

/* Themed scrollbar for the Logs modal */
.logs-modal-body {
    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: var(--accent-color) transparent;
}

/* WebKit-based browsers (Chrome, Edge, Safari) */
.logs-modal-body::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.logs-modal-body::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
}

.logs-modal-body::-webkit-scrollbar-thumb {
    background: var(--accent-color);
    border-radius: 10px;
    border: 2px solid transparent; /* create padding effect */
    background-clip: padding-box;
}

.logs-modal-body::-webkit-scrollbar-thumb:hover {
    filter: brightness(0.92);
}

/* Dark theme tweaks (uses same accent but can be customized) */
[data-theme="dark"] .logs-modal-body {
    scrollbar-color: var(--accent-color) transparent;
}

/* Ensure a dark scrollbar when the app uses the .dark class as well */
.dark .logs-modal-body,
[data-theme="dark"] .logs-modal-body {
    /* Firefox: darker thumb on a darker track */
    scrollbar-width: thin;
    scrollbar-color: #2a333a #0b0f12;
}

/* WebKit: dark theme scrollbar */
.dark .logs-modal-body::-webkit-scrollbar,
[data-theme="dark"] .logs-modal-body::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.dark .logs-modal-body::-webkit-scrollbar-track,
[data-theme="dark"] .logs-modal-body::-webkit-scrollbar-track {
    background: #0b0f12; /* very dark track */
    border-radius: 10px;
}

.dark .logs-modal-body::-webkit-scrollbar-thumb,
[data-theme="dark"] .logs-modal-body::-webkit-scrollbar-thumb {
    background: #2a333a; /* dark thumb that matches dark borders */
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: padding-box;
}

.dark .logs-modal-body::-webkit-scrollbar-thumb:hover,
[data-theme="dark"] .logs-modal-body::-webkit-scrollbar-thumb:hover {
    filter: brightness(1.12);
}

.animate-bio {
    animation: bioFadeIn 0.35s ease forwards;
    box-shadow: 0 0 0 rgba(255,255,255,0);
}

@keyframes bioFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px) scale(0.98);
        box-shadow: 0 0 20px rgba(255,255,255,0.05);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
        box-shadow: 0 0 0 rgba(255,255,255,0);
    }
}

.bio-edit-container {
    position: relative;
    width: 100%;
}

/* Le compteur intégré dans le coin */
.bio-counter {
    position: absolute;
    bottom: 8px;
    right: 12px;

    font-size: 12px;
    opacity: 0.8;

    background: rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(6px);
    padding: 3px 6px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.25);

    pointer-events: none; /* ne gêne pas l’écriture */
}

/* Thème sombre */
[data-theme="dark"] .bio-counter {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.2);
}

/* Warning quand on approche de la limite */
.bio-counter.warning {
    color: #e74c3c;
    border-color: rgba(231, 76, 60, 0.4);
}


`, "",{"version":3,"sources":["webpack://./src/styles/Profile.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,WAAW,eAAe,oCAAoC;IAC9D,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA,QAAQ;AACR;IACI,SAAS;IACT,eAAe,WAAW,2CAA2C;IACrE,gBAAgB;AACpB;;AAEA,SAAS;AACT;IACI,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA,aAAa;AACb;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;AACtB;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB,EAAE,qCAAqC;AAC9D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,SAAS,EAAE,gEAAgE;IAC3E,eAAe;IACf,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB,EAAE,sCAAsC;AAC5D;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA,aAAa;AACb;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA,2BAA2B;AAC3B,yBAAyB;AACzB;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,oDAAoD;IACpD,0CAA0C;IAC1C,sDAAsD;AAC1D;;AAEA,UAAU;AACV;IACI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI;QACI,0CAA0C;QAC1C,0BAA0B;IAC9B;IACA;QACI,2CAA2C;QAC3C,2BAA2B;IAC/B;AACJ;;;AAGA;IACI,mBAAmB,EAAE,SAAS;AAClC;;AAEA;IACI,mBAAmB,EAAE,SAAS;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,0BAA0B;IAC1B,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB,EAAE,iBAAiB;AACvC;;;;AAIA;IACI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;;AAGA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,0BAA0B;IAC1B,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,sCAAsC;AACtC,2BAA2B;AAC3B,0BAA0B;AAC1B,iDAAiD;AACjD,kBAAkB;AAClB,mBAAmB;AACnB,oBAAoB;AACpB,0BAA0B;AAC1B,8EAA8E;AAC9E,yBAAyB;AACzB,IAAI;;;AAGJ;IACI,kBAAkB,EAAE,6CAA6C;IACjE,aAAa;IACb,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC,EAAE,kCAAkC;IACpE,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;;IAEnB,qCAAqC;IACrC,0BAA0B;;IAE1B,2CAA2C;IAC3C,wBAAwB;;IAExB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAE,4BAA4B;AACtD;;AAEA,wBAAwB;AACxB;IACI,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA,iBAAiB;AACjB;IACI,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;AAC/C;;;;AAIA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;;IAER,iBAAiB;IACjB,mBAAmB;;IAEnB,qCAAqC;IACrC,2BAA2B;;IAE3B,2CAA2C;;IAE3C,wBAAwB;IACxB,eAAe;IACf,eAAe;;IAEf,sBAAsB;AAC1B;;AAEA,UAAU;AACV;IACI,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,qCAAqC;IACrC,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA,iBAAiB;AACjB;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA,eAAe;AACf;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,uBAAuB;IACvB,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0CAA0C;IAC1C,gGAAgG;AACpG;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,gFAAgF;AAChF;;IAEI,kCAAkC;IAClC,wBAAwB;IACxB,wCAAwC;IACxC,sCAAsC;AAC1C;;AAEA;;IAEI,+BAA+B;IAC/B,YAAY;IACZ,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;;IAEjB,qCAAqC;IACrC,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA,iBAAiB;AACjB;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA,2CAA2C;AAC3C;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA,wCAAwC;AACxC;IACI,YAAY;IACZ,qBAAqB;IACrB,gDAAgD;AACpD;;AAEA,iDAAiD;AACjD;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,6BAA6B,EAAE,0BAA0B;IACzD,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,+DAA+D;AAC/D;IACI,gDAAgD;AACpD;;AAEA,sEAAsE;AACtE;;IAEI,4CAA4C;IAC5C,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA,iCAAiC;AACjC;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,mBAAmB,EAAE,oBAAoB;IACzC,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB,EAAE,yCAAyC;IAC9D,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;QACvC,2CAA2C;IAC/C;IACA;QACI,UAAU;QACV,iCAAiC;QACjC,qCAAqC;IACzC;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;;IAEX,eAAe;IACf,YAAY;;IAEZ,+BAA+B;IAC/B,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;;IAE3C,oBAAoB,EAAE,2BAA2B;AACrD;;AAEA,iBAAiB;AACjB;IACI,qCAAqC;IACrC,sCAAsC;AAC1C;;AAEA,2CAA2C;AAC3C;IACI,cAAc;IACd,oCAAoC;AACxC","sourcesContent":["/* HEADER DU PROFIL */\r\n.public-profile-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n/* AVATAR */\r\n.public-profile-avatar {\r\n    width: 70px;              /* Taille cohérente avec ton thème */\r\n    height: 70px;\r\n    border-radius: 50%;\r\n    object-fit: cover;\r\n    border: 2px solid var(--border-color);\r\n}\r\n\r\n/* NOM */\r\n.public-profile-name {\r\n    margin: 0;\r\n    font-size: 18px;          /* Même taille que tes titres secondaires */\r\n    font-weight: 600;\r\n}\r\n\r\n/* ROLE */\r\n.public-profile-role {\r\n    margin-top: 4px;\r\n    opacity: 0.7;\r\n    font-size: 14px;\r\n}\r\n\r\n/* SECTIONS */\r\n.public-profile-section {\r\n    margin-top: 25px;\r\n}\r\n\r\n.public-profile-section h4 {\r\n    margin-bottom: 8px;\r\n    font-size: 15px;\r\n    opacity: 0.8;\r\n}\r\n\r\n.public-profile-section p,\r\n.public-profile-section li {\r\n    font-size: 14px;\r\n    opacity: 0.9;\r\n}\r\n\r\n/* LISTE DES STATS */\r\n.public-profile-section ul {\r\n    padding-left: 18px;\r\n}\r\n\r\n/* BANNIÈRE */\r\n.profile-banner {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 180px;\r\n    border-radius: 12px;\r\n    overflow: visible;\r\n    margin-bottom: 40px; /* pour laisser la place à l’avatar */\r\n}\r\n\r\n.profile-banner-img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: bottom;\r\n    border-radius: 12px;\r\n}\r\n\r\n/* TITRE DU PROFIL */\r\n.chart-title {\r\n    margin: 0; /* reset margin so vertical alignment is controlled by the row */\r\n    font-size: 20px;\r\n    line-height: 1;\r\n}\r\n\r\n/* Title row with aligned actions */\r\n.profile-title-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    margin-top: 10px; /* keep previous spacing from avatar */\r\n}\r\n\r\n.profile-title-row .chart-title {\r\n    display: inline-flex;\r\n    align-items: center;\r\n}\r\n\r\n.logs-btn {\r\n    height: 36px;\r\n    min-width: 36px;\r\n    padding: 6px 10px;\r\n}\r\n\r\n/* SECTIONS */\r\n.public-profile-section {\r\n    margin-top: 25px;\r\n}\r\n\r\n.public-profile-section h4 {\r\n    margin-bottom: 8px;\r\n    font-size: 15px;\r\n    opacity: 0.8;\r\n}\r\n\r\n.public-profile-section p,\r\n.public-profile-section li {\r\n    font-size: 14px;\r\n    opacity: 0.9;\r\n}\r\n\r\n.public-profile-badges {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-top: 6px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n/* Style général */\r\n.badge {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 4px 10px;\r\n    border-radius: 8px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: white;\r\n}\r\n\r\n/* Couleurs selon le rôle */\r\n/* Container des badges */\r\n.public-profile-badges {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-top: 6px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n/* Badge Admin animé */\r\n.badge-admin-animated {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 4px 12px;\r\n    border-radius: 8px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: white;\r\n    background: linear-gradient(90deg, #ff4d4d, #ff1a1a);\r\n    box-shadow: 0 0 8px rgba(255, 50, 50, 0.6);\r\n    animation: adminGlow 2s infinite alternate ease-in-out;\r\n}\r\n\r\n/* Icône */\r\n.badge-admin-animated i {\r\n    font-size: 12px;\r\n}\r\n\r\n/* Animation glow */\r\n@keyframes adminGlow {\r\n    0% {\r\n        box-shadow: 0 0 6px rgba(255, 50, 50, 0.4);\r\n        transform: translateY(0px);\r\n    }\r\n    100% {\r\n        box-shadow: 0 0 14px rgba(255, 50, 50, 0.9);\r\n        transform: translateY(-1px);\r\n    }\r\n}\r\n\r\n\r\n.badge-mod {\r\n    background: #3498db; /* bleu */\r\n}\r\n\r\n.badge-user {\r\n    background: #7f8c8d; /* gris */\r\n}\r\n\r\n.badge i {\r\n    font-size: 12px;\r\n}\r\n\r\n.edit-url-box {\r\n    margin-top: 15px;\r\n    margin-bottom: 15px;\r\n    padding: 12px;\r\n    background: var(--card-bg);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 8px;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    position: static; /* 🔥 IMPORTANT */\r\n}\r\n\r\n\r\n\r\n.edit-url-box input {\r\n    flex: 1;\r\n    padding: 8px;\r\n    border-radius: 6px;\r\n    border: 1px solid var(--border-color);\r\n    background: var(--card-bg);\r\n    color: var(--text-color);\r\n}\r\n\r\n.save-url-btn {\r\n    padding: 8px 14px;\r\n    background: var(--accent-color);\r\n    color: white;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.cancel-url-btn {\r\n    padding: 8px 14px;\r\n    background: #555;\r\n    color: white;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n/* Bouton modifier bannière */\r\n.edit-banner-btn {\r\n    position: absolute;\r\n    right: 20px;\r\n    bottom: 20px;\r\n    background: rgba(0,0,0,0.5);\r\n    color: white;\r\n    padding: 6px 12px;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    border: none;\r\n    cursor: pointer;\r\n    backdrop-filter: blur(4px);\r\n    transition: 0.2s;\r\n}\r\n\r\n.edit-banner-btn:hover {\r\n    background: rgba(0,0,0,0.7);\r\n}\r\n\r\n/* Bouton modifier avatar */\r\n.edit-avatar-btn {\r\n    position: absolute;\r\n    bottom: -10px;\r\n    left: 110px;\r\n    background: var(--card-bg);\r\n    border: 2px solid var(--border-color);\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: 0.2s;\r\n}\r\n\r\n.edit-avatar-btn:hover {\r\n    transform: scale(1.1);\r\n}\r\n\r\n/* AVATAR QUI DÉPASSE DE LA BANNIÈRE */\r\n/*.profile-banner-avatar {*/\r\n/*    position: absolute;*/\r\n/*    bottom: -35px; !* dépasse comme Discord *!*/\r\n/*    left: 30px;*/\r\n/*    width: 80px;*/\r\n/*    height: 80px;*/\r\n/*    border-radius: 50%;*/\r\n/*    border: 4px solid var(--card-bg); !* cercle propre même en dark mode *!*/\r\n/*    object-fit: cover;*/\r\n/*}*/\r\n\r\n\r\n.avatar-wrapper2 {\r\n    position: absolute; /* même positionnement que ton avatar avant */\r\n    bottom: -35px;\r\n    left: 40px;\r\n    width: 80px;\r\n    height: 80px;\r\n}\r\n\r\n.profile-banner-avatar {\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n    border: 4px solid var(--card-bg); /*cercle propre même en dark mode*/\r\n    object-fit: cover;\r\n}\r\n\r\n/* Le point vert */\r\n.status-dot2 {\r\n    position: absolute;\r\n    bottom: 5px;\r\n    right: 5px;\r\n    width: 18px;\r\n    height: 18px;\r\n    border-radius: 50%;\r\n    border: 3px solid var(--card-bg);\r\n}\r\n\r\n.status-dot2.online {\r\n    background-color: #2ecc71;\r\n}\r\n\r\n.status-dot2.offline {\r\n    background-color: #7f8c8d;\r\n}\r\n\r\n.profile-bio {\r\n    margin-top: 20px;\r\n}\r\n\r\n.bio-textarea {\r\n    width: 100%;\r\n    min-height: 120px;\r\n    padding: 12px;\r\n    border-radius: 10px;\r\n\r\n    background: rgba(255, 255, 255, 0.15);\r\n    backdrop-filter: blur(8px);\r\n\r\n    border: 1px solid rgba(255, 255, 255, 0.35);\r\n    color: var(--text-color);\r\n\r\n    resize: none;\r\n    outline: none;\r\n    transition: 0.25s ease;\r\n    padding-bottom: 32px; /* espace pour le compteur */\r\n}\r\n\r\n/* Effet focus moderne */\r\n.bio-textarea:focus {\r\n    border-color: var(--accent-color);\r\n    box-shadow: 0 0 8px rgba(52, 152, 219, 0.4);\r\n}\r\n\r\n/* Thème sombre */\r\n[data-theme=\"dark\"] .bio-textarea {\r\n    background: rgba(0, 0, 0, 0.25);\r\n    border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n[data-theme=\"dark\"] .bio-textarea:focus {\r\n    border-color: var(--accent-color);\r\n    box-shadow: 0 0 8px rgba(74, 163, 255, 0.4);\r\n}\r\n\r\n\r\n\r\n.bio-actions {\r\n    margin-top: 10px;\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.save-bio-btn {\r\n    padding: 8px 14px;\r\n    background: var(--accent-color);\r\n    color: white;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.cancel-bio-btn {\r\n    padding: 8px 14px;\r\n    background: #555;\r\n    color: white;\r\n    border-radius: 6px;\r\n    border: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.edit-glass-btn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n\r\n    padding: 7px 12px;\r\n    border-radius: 10px;\r\n\r\n    background: rgba(255, 255, 255, 0.15);\r\n    backdrop-filter: blur(10px);\r\n\r\n    border: 1px solid rgba(255, 255, 255, 0.25);\r\n\r\n    color: var(--text-color);\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n\r\n    transition: 0.25s ease;\r\n}\r\n\r\n/* Icône */\r\n.edit-glass-btn i {\r\n    font-size: 14px;\r\n}\r\n\r\n/* Hover */\r\n.edit-glass-btn:hover {\r\n    background: rgba(255, 255, 255, 0.25);\r\n    border-color: rgba(255, 255, 255, 0.45);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n/* Thème sombre */\r\n[data-theme=\"dark\"] .edit-glass-btn {\r\n    background: rgba(0, 0, 0, 0.25);\r\n    border-color: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n/* Logs modal */\r\n.logs-btn {\r\n    background: var(--card-bg);\r\n    border: 1px solid var(--border-color);\r\n    color: var(--text-color);\r\n    padding: 8px 10px;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.logs-modal-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0,0,0,0.45);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1200;\r\n}\r\n\r\n.logs-modal {\r\n    width: min(1100px, 95%);\r\n    max-height: 80vh;\r\n    background: var(--card-bg);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.logs-modal-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 14px 18px;\r\n    border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.logs-modal-body {\r\n    padding: 12px 16px;\r\n    overflow: auto;\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.logs-modal-footer {\r\n    padding: 10px 16px;\r\n    border-top: 1px solid var(--border-color);\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 10px;\r\n}\r\n\r\n.close-modal {\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 22px;\r\n    cursor: pointer;\r\n    color: var(--text-color);\r\n}\r\n\r\n.logs-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n}\r\n\r\n.logs-table th, .logs-table td {\r\n    padding: 8px 10px;\r\n    text-align: left;\r\n    border-bottom: 1px solid var(--border-color);\r\n    font-size: 13px;\r\n}\r\n\r\n.load-more {\r\n    padding: 8px 12px;\r\n    min-width: 140px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    background: transparent;\r\n    color: var(--accent-color);\r\n    border: 1px solid var(--accent-color);\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n    box-shadow: 0 6px 18px rgba(16,24,40,0.04);\r\n    transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease, color 160ms ease;\r\n}\r\n\r\n.load-more:hover {\r\n    transform: translateY(-3px);\r\n    background: var(--accent-color);\r\n    color: white;\r\n    box-shadow: 0 10px 24px rgba(16,24,40,0.08);\r\n}\r\n\r\n.load-more:active {\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.load-more:focus {\r\n    outline: 2px solid rgba(0,0,0,0.06);\r\n    outline-offset: 2px;\r\n}\r\n\r\n.load-more[disabled] {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n    transform: none;\r\n    box-shadow: none;\r\n}\r\n\r\n/* Dark theme: subtle light-outline, hover fills with accent to remain visible */\r\n.dark .load-more,\r\n[data-theme=\"dark\"] .load-more {\r\n    background: rgba(255,255,255,0.03);\r\n    color: var(--text-color);\r\n    border: 1px solid rgba(255,255,255,0.06);\r\n    box-shadow: 0 6px 18px rgba(0,0,0,0.5);\r\n}\r\n\r\n.dark .load-more:hover,\r\n[data-theme=\"dark\"] .load-more:hover {\r\n    background: var(--accent-color);\r\n    color: white;\r\n    box-shadow: 0 10px 26px rgba(0,0,0,0.6);\r\n}\r\n\r\n[data-theme=\"dark\"] .edit-glass-btn:hover {\r\n    background: rgba(0, 0, 0, 0.35);\r\n    border-color: rgba(255, 255, 255, 0.35);\r\n}\r\n\r\n.bio-edit-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n}\r\n\r\n.bio-counter {\r\n    font-size: 13px;\r\n    opacity: 0.7;\r\n    text-align: right;\r\n    width: fit-content;\r\n    margin-left: auto;\r\n\r\n    background: rgba(255, 255, 255, 0.12);\r\n    backdrop-filter: blur(6px);\r\n    padding: 4px 8px;\r\n    border-radius: 6px;\r\n    border: 1px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n/* Thème sombre */\r\n[data-theme=\"dark\"] .bio-counter {\r\n    background: rgba(0, 0, 0, 0.25);\r\n    border-color: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n/* Warning quand on approche de la limite */\r\n.bio-counter.warning {\r\n    color: #e74c3c;\r\n    border-color: rgba(231, 76, 60, 0.4);\r\n}\r\n\r\n/* Themed scrollbar for the Logs modal */\r\n.logs-modal-body {\r\n    /* Firefox */\r\n    scrollbar-width: thin;\r\n    scrollbar-color: var(--accent-color) transparent;\r\n}\r\n\r\n/* WebKit-based browsers (Chrome, Edge, Safari) */\r\n.logs-modal-body::-webkit-scrollbar {\r\n    width: 10px;\r\n    height: 10px;\r\n}\r\n\r\n.logs-modal-body::-webkit-scrollbar-track {\r\n    background: transparent;\r\n    border-radius: 10px;\r\n}\r\n\r\n.logs-modal-body::-webkit-scrollbar-thumb {\r\n    background: var(--accent-color);\r\n    border-radius: 10px;\r\n    border: 2px solid transparent; /* create padding effect */\r\n    background-clip: padding-box;\r\n}\r\n\r\n.logs-modal-body::-webkit-scrollbar-thumb:hover {\r\n    filter: brightness(0.92);\r\n}\r\n\r\n/* Dark theme tweaks (uses same accent but can be customized) */\r\n[data-theme=\"dark\"] .logs-modal-body {\r\n    scrollbar-color: var(--accent-color) transparent;\r\n}\r\n\r\n/* Ensure a dark scrollbar when the app uses the .dark class as well */\r\n.dark .logs-modal-body,\r\n[data-theme=\"dark\"] .logs-modal-body {\r\n    /* Firefox: darker thumb on a darker track */\r\n    scrollbar-width: thin;\r\n    scrollbar-color: #2a333a #0b0f12;\r\n}\r\n\r\n/* WebKit: dark theme scrollbar */\r\n.dark .logs-modal-body::-webkit-scrollbar,\r\n[data-theme=\"dark\"] .logs-modal-body::-webkit-scrollbar {\r\n    width: 10px;\r\n    height: 10px;\r\n}\r\n\r\n.dark .logs-modal-body::-webkit-scrollbar-track,\r\n[data-theme=\"dark\"] .logs-modal-body::-webkit-scrollbar-track {\r\n    background: #0b0f12; /* very dark track */\r\n    border-radius: 10px;\r\n}\r\n\r\n.dark .logs-modal-body::-webkit-scrollbar-thumb,\r\n[data-theme=\"dark\"] .logs-modal-body::-webkit-scrollbar-thumb {\r\n    background: #2a333a; /* dark thumb that matches dark borders */\r\n    border-radius: 10px;\r\n    border: 2px solid transparent;\r\n    background-clip: padding-box;\r\n}\r\n\r\n.dark .logs-modal-body::-webkit-scrollbar-thumb:hover,\r\n[data-theme=\"dark\"] .logs-modal-body::-webkit-scrollbar-thumb:hover {\r\n    filter: brightness(1.12);\r\n}\r\n\r\n.animate-bio {\r\n    animation: bioFadeIn 0.35s ease forwards;\r\n    box-shadow: 0 0 0 rgba(255,255,255,0);\r\n}\r\n\r\n@keyframes bioFadeIn {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translateY(10px) scale(0.98);\r\n        box-shadow: 0 0 20px rgba(255,255,255,0.05);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: translateY(0) scale(1);\r\n        box-shadow: 0 0 0 rgba(255,255,255,0);\r\n    }\r\n}\r\n\r\n.bio-edit-container {\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n/* Le compteur intégré dans le coin */\r\n.bio-counter {\r\n    position: absolute;\r\n    bottom: 8px;\r\n    right: 12px;\r\n\r\n    font-size: 12px;\r\n    opacity: 0.8;\r\n\r\n    background: rgba(0, 0, 0, 0.15);\r\n    backdrop-filter: blur(6px);\r\n    padding: 3px 6px;\r\n    border-radius: 6px;\r\n    border: 1px solid rgba(255, 255, 255, 0.25);\r\n\r\n    pointer-events: none; /* ne gêne pas l’écriture */\r\n}\r\n\r\n/* Thème sombre */\r\n[data-theme=\"dark\"] .bio-counter {\r\n    background: rgba(255, 255, 255, 0.12);\r\n    border-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n/* Warning quand on approche de la limite */\r\n.bio-counter.warning {\r\n    color: #e74c3c;\r\n    border-color: rgba(231, 76, 60, 0.4);\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
